import { useViewsSelectAllStore } from '~/components/v2/store/features/views/useViewsSelectAllStore';
import { centralizedBoardIdSelector, isAncestorOfCentralizedBoardSelector } from '~/store/centralizedBoard/selectors';
import { useAirSelector } from '~/utils/ReduxUtils';

export const useIsInSelectAllSubtree = () => {
  const selectAll = useViewsSelectAllStore((state) => state.selectAll);
  const includeNestedItems = useViewsSelectAllStore((state) => state.includeNestedItems);
  const selectAllRootBoardId = useViewsSelectAllStore((state) => state.selectAllRootBoardId);

  const currentBoardId = useAirSelector(centralizedBoardIdSelector);
  const isRootAncestorOfCurrent = useAirSelector((st) =>
    selectAllRootBoardId ? isAncestorOfCentralizedBoardSelector(st, selectAllRootBoardId) : false,
  );

  const isInSubtree = !selectAllRootBoardId || currentBoardId === selectAllRootBoardId || isRootAncestorOfCurrent;

  return selectAll && includeNestedItems && isInSubtree;
};
